'use client'

import { ReactNode } from 'react'
import { useRouter } from 'next/navigation'

type NavigateToContactProps = {
  children: ReactNode
  locale: string
  className?: string
  onClick?: () => void
}

export default function NavigateToContact({ children, locale, className, onClick }: NavigateToContactProps) {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (onClick) onClick()
    
    // Store the target section in sessionStorage to scroll immediately on page load
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('scrollToSection', 'contact')
    }
    
    // Navigate to v1 page with hash
    router.push(`/${locale}/v1#contact`)
  }

  return (
    <a href={`/${locale}/v1#contact`} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
